import React, {useMemo} from 'react';
import type {SxProps} from '@mui/material';
import { Tooltip} from '@mui/material';
import Chip from '@mui/material/Chip';
import {useLocalization} from 'localization';
import {ColorPalette} from 'theme';
import {Layout} from 'components';

type Props = {
  isMainForm: boolean;
  /** undefined if NORAF was not loaded/found */
  isMainFormInNoraf: boolean | undefined;
  sx?: SxProps;
};

export const NameVariantMainForm: React.FC<Props> = ({
  isMainForm,
  isMainFormInNoraf,
  sx,
}) => {
  const {t} = useLocalization();

  const {label, help} = useMemo(() => {
    return {
      label: isMainForm
        ? t('form.global.field.nameVariantMain.label')
        : isMainFormInNoraf
          ? t('form.global.field.nameVariantNoraf.label')
          : '',
      help:
        isMainForm && isMainFormInNoraf
          ? t('page.agents.nameVariants.ebbaAndNoraf')
          : isMainForm
            ? t('page.agents.nameVariants.onlyEbba')
            : isMainFormInNoraf
              ? t('page.agents.nameVariants.onlyNoraf')
              : '',
    };
  }, [isMainForm, isMainFormInNoraf, t]);

  return (
    <Layout hidden={!isMainForm && !isMainFormInNoraf} adjustCenter sx={sx}>
      <Tooltip title={help}>
        <Chip
          size="small"
          label={label}
          sx={{
            background: isMainForm
              ? isMainFormInNoraf === undefined
                ? ColorPalette.spot.urgent
                : isMainFormInNoraf
                  ? ColorPalette.spot.new40
                  : ColorPalette.spot.change
              : ColorPalette.spot.change,
          }}
        />
      </Tooltip>
    </Layout>
  );
};
